// Vendor libraries
import { createReducer, on, combineReducers } from '@ngrx/store';
// NgRx actions
import { addWatchlistItem, createWatchlist, fetchUserWatchlists, removeWatchlistItem, removeWatchlistItemError, removeWatchlistSecurityObject, setWatchlistSecurityObject, setWatchlistsFetchFailure, setWatchlistsFetchSuccess, setWatchlistItemError, } from './add-to-watchlist-modal.actions';
// Constants
export const ADD_TO_WATCHLIST_STATE_SLICE_KEY = 'addToWatchlist';
const securityObject = createReducer(null, on(removeWatchlistSecurityObject, () => {
    return null;
}), on(setWatchlistSecurityObject, (state, action) => {
    if (action.securityObject)
        return { ...action.securityObject };
    return null;
}));
const fetchRequest = createReducer({ status: '' }, on(setWatchlistsFetchSuccess, () => {
    return { status: 'success' };
}), on(setWatchlistsFetchFailure, () => {
    return { status: 'error' };
}), on(fetchUserWatchlists, () => {
    return { status: 'pending' };
}));
const watchlistItemError = createReducer('', on(setWatchlistItemError, (state, action) => {
    return action.errorMessage;
}), on(removeWatchlistItemError, () => {
    return '';
}));
export const itemsMap = createReducer({}, on(setWatchlistsFetchSuccess, (state, action) => {
    return action.itemsMap;
}), on(addWatchlistItem, (state, action) => {
    const { watchlist, watchlistItem } = action;
    const { watchlistType } = watchlist;
    return {
        ...state,
        [watchlistType]: state[watchlistType].map((w) => {
            if (w.id === watchlist.id) {
                return {
                    ...w,
                    watchlistItems: [...w.watchlistItems, watchlistItem],
                };
            }
            return w;
        }),
    };
}), on(createWatchlist, (state, action) => {
    const { watchlist } = action;
    const { watchlistType } = watchlist;
    return { ...state, [watchlistType]: [...state[watchlistType], watchlist] };
}), on(removeWatchlistItem, (state, action) => {
    const { watchlist, watchlistItem } = action;
    const { watchlistType } = watchlist;
    return {
        ...state,
        [watchlistType]: state[watchlistType].map((w) => {
            if (w.id === watchlist.id) {
                return {
                    ...w,
                    watchlistItems: w.watchlistItems.filter((item) => {
                        return item.securityId !== watchlistItem.securityId;
                    }),
                };
            }
            return w;
        }),
    };
}));
export const addToWatchlist = combineReducers({
    securityObject,
    fetchRequest,
    itemsMap,
    watchlistItemError,
});
